// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	$(document).ready(function () {

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		const SELECTOR_DATEPICKER$1 = '#booking__calendars'

		const SELECTOR_DATE$1 = '#arrive'
		const SELECTOR_DATE$2 = '#depart'
		const SELECTOR_DATE$3 = '#altDates'

		let opened = 0
		let start = $(SELECTOR_DATE$1).attr('value')
		let end = $(SELECTOR_DATE$2).attr('value')

		const datepickerBooking = () => {
			$(SELECTOR_DATEPICKER$1).datepicker({
				dateFormat: 'yy-mm-dd',
				numberOfMonths: 2,
				minDate: new Date(),
				
				beforeShowDay: function (date) {
					setTimeout(function() {
						document.querySelectorAll('.ui-datepicker-calendar td a').forEach(e => {
							e.setAttribute('tabindex', '-1');
						})
					}, 1000);
					$.datepicker._defaults.dateFormat = 'yy-mm-dd'

					let startDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start)

					let endDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end)

					if (date.getTime() == startDate.getTime()) {
						return [true, 'startday']
					} else {
						if (date.getTime() == endDate.getTime()) {
							return [true, 'endday']
						} else {
							if (date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime()) {
								return [true, 'days']
							} else {
								return [true, '']
							}
						}
					}
				},
				onSelect: function (date) {
					let arrive = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start)
					let departure = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end)
					let selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, date)

					if (opened == 0) {
						opened = 1
						start = date
						end = date
					} else {
						opened = 0
						if (selectedDate <= arrive) {
							end = start
							start = date
						} else {
							end = date
						}
					}

					let SplitArrive = start.split('-')
					let SplitDeparture = end.split('-')

					let start2= SplitArrive[1] + '/' + SplitArrive[2] + '/' + SplitArrive[0];
					let end2 = SplitDeparture[1] + '/' + SplitDeparture[2] + '/' + SplitDeparture[0];

					$(SELECTOR_DATE$1).attr('value', start2);
					$(SELECTOR_DATE$2).attr('value', end2);

					$(SELECTOR_DATE$3).attr('value',(SplitArrive[1] + '/' + SplitArrive[2] + '/' + SplitArrive[0]) + ' - ' + (SplitDeparture[1] + '/' + SplitDeparture[2] + '/' + SplitDeparture[0]))
				},
			});
		}

		datepickerBooking();

		if(document.getElementById('tbBooking')){
			document.querySelector('.js-open-booking').addEventListener('click', ()=>{
				document.getElementById('tbBooking').classList.add('show');
			})

			document.querySelector('.js-close-booking').addEventListener('click', ()=>{
				document.getElementById('tbBooking').classList.remove('show');
			})
		}
		if(document.getElementsByClassName('show')){
			document.querySelectorAll('.js-open-booking')[1].addEventListener('click', ()=>{
				document.getElementById('tbBooking').classList.add('show');
				document.getElementById('main-nav').classList.remove('show');
			})

			document.querySelectorAll('.js-open-menu')[1].addEventListener('click', ()=>{
				document.getElementById('main-nav').classList.add('show');
				document.getElementById('tbBooking').classList.remove('show');
			})
		}

	});

	window.onload = function() {
		if(document.getElementById('home')){
			scrollDownAction(20, 'scroll');

			scrollW();
			window.addEventListener('scroll', function(){
				scrollW();
			})
		}

		var data = document.URL;
		if(data.indexOf("&filter") != -1){
			data = data.split("#")[1];
			data = data.split('&filter=')[0];
			let dataFilter = document.URL.split('&filter=')[1];

			var top_ele = $("#" + data).offset().top;
			$("html,body").animate({ scrollTop: top_ele - 100 }, 1500).delay(1000);

			document.querySelector('[data-tag="'+ dataFilter+'"]').click();

		}else if (data.indexOf("#") != -1) {
			data = data.split("#")[1];
			var top_ele = $("#" + data).offset().top;
			$("html,body").animate({ scrollTop: top_ele - 100 }, 1500).delay(1000);
		}

		document.querySelectorAll('.scroll-click').forEach((button)=>{
			button.addEventListener('click',()=>{
				let href = button.getAttribute('href');
				href = href.split('#')[1];
				var top_ele = $("#" + href).offset().top;
				document.querySelector('#main-nav').classList.remove('show');
				$("html,body").animate({ scrollTop: top_ele - 100 }, 1500).delay(1000);
			});
		});


		document.querySelectorAll('.scroll-filter').forEach((button)=>{
			button.addEventListener('click',()=>{
				let href = button.getAttribute('href');
				let elementScroll = href.split('#')[1];
				elementScroll = elementScroll.split('&filter=')[0];
				let dataFilter = href.split('&filter=')[1];

				console.log(elementScroll, dataFilter);

				var top_ele = $("#" + elementScroll).offset().top;
				document.querySelector('#main-nav').classList.remove('show');
				document.querySelector('[data-tag="'+ dataFilter+'"]').click();
				$("html,body").animate({ scrollTop: top_ele - 100 }, 1500).delay(1000);
			});
		})
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.querySelector('.main-menu__header').classList.add('down');
				document.getElementById('header').classList.remove('up');
				document.querySelector('.main-menu__header').classList.remove('up');
				let src_scroll = document.querySelector('.header__logo img').dataset.scroll;
				document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src', src_scroll);
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.querySelector('.main-menu__header').classList.add('up');
				document.getElementById('header').classList.remove('down');
				document.querySelector('.main-menu__header').classList.remove('down');
				let src_scroll = document.querySelector('.header__logo img').dataset.scroll;
				document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src', src_scroll);
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
			document.querySelector('.main-menu__header').classList.remove('up');
			document.querySelector('.main-menu__header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}